import BaseButton from "@/components/common/baseButton";
import "./formsCreateGroupOrder.css";
import { useNavigate } from "react-router-dom";
import ArrowElement from "@/assets/images/ArrowElement.svg";
import { useTranslation } from "react-i18next";
import BaseInput from "@/components/common/baseInput";
import { Checkbox, FormControlLabel, MenuItem, Radio, RadioGroup } from "@mui/material";
import NumericFormatCustom from "@/components/common/numericFormatCustom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import BaseDateInput from "@/components/common/baseDateInput";
import { formatDate } from "@/util";
import { useEffect, useState } from "react";
import { Region } from "@/models/apiModels";
import { CreateGroupOrderRequest } from "@/models/forms";
import {
    AdditionDrinksTypes,
    ArtistPerformanceTypes,
    FormMessageTypes,
    HotelLevelTypes,
    MealTypes,
    SpecialRequestStayTypes,
    StayingRequestTypes,
    VisitorsTypes,
} from "@/models/enums";
import dayjs from "dayjs";
import api from "@/services/api";
import popupService from "@/services/popupService";

const FormsCreateGroupOrder = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const currentDate = new Date();
    const [regions, setRegions] = useState<Region[]>([]);
    const [mealTypeCheck, setMealTypeCheck] = useState({
        isCheckedRefreshmentsArrival: false,
        isCheckedFullBreakfast: false,
        isCheckedRefreshmentsWay: false,
        isCheckedLunch: false,
        isCheckedDinner: false,
    });
    const [stayingRequestCheck, setStayingRequestCheck] = useState({
        isCheckedWeekendOne: false,
        isCheckedWeekendTwo: false,
        isCheckedMidweekOne: false,
        isCheckedMidweekTwo: false,
        isCheckedMidweekThree: false,
        isCheckedMidweekFour: false,
    });
    const [hotelLevelCheck, setHotelLevelCheck] = useState({
        isCheckedThreeStar: false,
        isCheckedFourStar: false,
        isCheckedFiveStar: false,
    });
    const [specialRequestCheck, setSpecialRequestCheck] = useState({
        isCheckedFirstNight: false,
        isCheckedSecondNight: false,
        isCheckedThirdNight: false,
        isCheckedFourthNight: false,
    });
    const [additionDrinkCheck, setAdditionDrinkCheck] = useState({
        isCheckedDrinkOne: false,
        isCheckedDrinkTwo: false,
        isCheckedDrinkThree: false,
        isCheckedDrinkFour: false,
    });
    const [createGroupOrderRequest, setCreateGroupOrderRequest] = useState<CreateGroupOrderRequest>({
        messageTypes: null,
        groupName: "",
        mobile: "",
        email: "",
        purposeOfVacation: "",
        numberRoomsDesired: null,
        desiredRegionOneId: null,
        desiredRegionTwoId: null,
        desiredRegionThreeId: null,
        budgetPerEmployee: "",
        familyBudget: "",
        budgetForCouple: "",
        budgetComments: "",
        stayingRequestType: null,
        stayingRequestComments: "",
        hotelLevelType: null,
        visitors: VisitorsTypes.EmployeesOnly,
        needBus: true,
        needGuide: true,
        mealType: null,
        mealComments: "",
        interestedTrip: true,
        interestedTripBudget: "",
        interestedTripComments: "",
        wantIncorporateLectureRecognition: true,
        incorporateLectureRecognitionBudget: "",
        incorporateLectureRecognitionComments: "",
        alternativeHolidayDateOne: null,
        alternativeHolidayDateTwo: null,
        alternativeHolidayDateThree: null,
        alternativeHolidayDateComments: "",
        interestedArtist: true,
        specialRequestStayType: null,
        eveningArtistBudget: "",
        generalBudget: "",
        additionDrinksOnEvent: true,
        additionDrinksType: null,
        additionDrinksComments: "",
        artistPerformanceType: ArtistPerformanceTypes.InsideHotel,
        artistPerformanceComments: "",
        additionCoffeeCake: true,
        additionCoffeeCakeComments: "",
        otherEventsNeeded: true,
        otherEventsNeededComments: "",
    });

    async function getCreateGroupOrderInitData() {
        const regionsListDataResponsePromise = api.getRegions();
        setRegions((await regionsListDataResponsePromise).data);
    }

    const handleCheckedRefreshmentsOnArrival = () => {
        setMealTypeCheck((prevData) => ({
            ...prevData,
            isCheckedRefreshmentsArrival: !mealTypeCheck.isCheckedRefreshmentsArrival,
        }));
        handleChangeMealType(
            !mealTypeCheck.isCheckedRefreshmentsArrival,
            MealTypes[MealTypes.RefreshmentsOnArrival] + ","
        );
    };

    const handleCheckedFullBreakfast = () => {
        setMealTypeCheck((prevData) => ({
            ...prevData,
            isCheckedFullBreakfast: !mealTypeCheck.isCheckedFullBreakfast,
        }));
        handleChangeMealType(!mealTypeCheck.isCheckedFullBreakfast, MealTypes[MealTypes.FullBreakfast] + ",");
    };

    const handleCheckedRefreshmentsWay = () => {
        setMealTypeCheck((prevData) => ({
            ...prevData,
            isCheckedRefreshmentsWay: !mealTypeCheck.isCheckedRefreshmentsWay,
        }));
        handleChangeMealType(!mealTypeCheck.isCheckedRefreshmentsWay, MealTypes[MealTypes.RefreshmentsOnTheWay] + ",");
    };

    const handleCheckedLunch = () => {
        setMealTypeCheck((prevData) => ({
            ...prevData,
            isCheckedLunch: !mealTypeCheck.isCheckedLunch,
        }));
        handleChangeMealType(!mealTypeCheck.isCheckedLunch, MealTypes[MealTypes.Lunch] + ",");
    };

    const handleCheckedDinner = () => {
        setMealTypeCheck((prevData) => ({
            ...prevData,
            isCheckedDinner: !mealTypeCheck.isCheckedDinner,
        }));
        handleChangeMealType(!mealTypeCheck.isCheckedDinner, MealTypes[MealTypes.Dinner] + ",");
    };
    function handleChangeMealType(isChange: boolean, enumType: string) {
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            mealType: isChange ? (prevData.mealType ?? "") + enumType : prevData.mealType?.replace(enumType, "") ?? "",
        }));
    }

    function handleOnChangeDateOne(e: any) {
        const date = dayjs(e?.toString());
        const formattedDate = date.isValid() ? date.format("YYYY-MM-DD") : "";
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            alternativeHolidayDateOne: e ? formattedDate : null,
        }));
    }

    function handleOnChangeDateTwo(e: any) {
        const date = dayjs(e?.toString());
        const formattedDate = date.isValid() ? date.format("YYYY-MM-DD") : "";
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            alternativeHolidayDateTwo: e ? formattedDate : null,
        }));
    }

    function handleOnChangeDateThree(e: any) {
        const date = dayjs(e?.toString());
        const formattedDate = date.isValid() ? date.format("YYYY-MM-DD") : "";
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            alternativeHolidayDateThree: e ? formattedDate : null,
        }));
    }

    const handleCheckedWeekendOne = () => {
        setStayingRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedWeekendOne: !stayingRequestCheck.isCheckedWeekendOne,
        }));
        handleChangeStayingRequestType(
            !stayingRequestCheck.isCheckedWeekendOne,
            StayingRequestTypes[StayingRequestTypes.WeekendOneNight] + ","
        );
    };

    const handleCheckedWeekendTwo = () => {
        setStayingRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedWeekendTwo: !stayingRequestCheck.isCheckedWeekendTwo,
        }));
        handleChangeStayingRequestType(
            !stayingRequestCheck.isCheckedWeekendTwo,
            StayingRequestTypes[StayingRequestTypes.WeekendTwoNight] + ","
        );
    };

    const handleCheckedMidweekOne = () => {
        setStayingRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedMidweekOne: !stayingRequestCheck.isCheckedMidweekOne,
        }));
        handleChangeStayingRequestType(
            !stayingRequestCheck.isCheckedMidweekOne,
            StayingRequestTypes[StayingRequestTypes.MidweekOneNight] + ","
        );
    };

    const handleCheckedMidweekTwo = () => {
        setStayingRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedMidweekTwo: !stayingRequestCheck.isCheckedMidweekTwo,
        }));
        handleChangeStayingRequestType(
            !stayingRequestCheck.isCheckedMidweekTwo,
            StayingRequestTypes[StayingRequestTypes.MidweekTwoNights] + ","
        );
    };

    const handleCheckedMidweekThree = () => {
        setStayingRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedMidweekThree: !stayingRequestCheck.isCheckedMidweekThree,
        }));
        handleChangeStayingRequestType(
            !stayingRequestCheck.isCheckedMidweekThree,
            StayingRequestTypes[StayingRequestTypes.MidweekThreeNights] + ","
        );
    };

    const handleCheckedMidweekFour = () => {
        setStayingRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedMidweekFour: !stayingRequestCheck.isCheckedMidweekFour,
        }));
        handleChangeStayingRequestType(
            !stayingRequestCheck.isCheckedMidweekFour,
            StayingRequestTypes[StayingRequestTypes.MidweekFourNights] + ","
        );
    };

    function handleChangeStayingRequestType(isChange: boolean, enumType: string) {
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            stayingRequestType: isChange
                ? (prevData.stayingRequestType ?? "") + enumType
                : prevData.stayingRequestType?.replace(enumType, "") ?? "",
        }));
    }

    const handleCheckedThreeStar = () => {
        setHotelLevelCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedThreeStar: !hotelLevelCheck.isCheckedThreeStar,
        }));
        handleChangeHotelLevelType(
            !hotelLevelCheck.isCheckedThreeStar,
            HotelLevelTypes[HotelLevelTypes.ThreeStars] + ","
        );
    };

    const handleCheckedFourStar = () => {
        setHotelLevelCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedFourStar: !hotelLevelCheck.isCheckedFourStar,
        }));
        handleChangeHotelLevelType(
            !hotelLevelCheck.isCheckedFourStar,
            HotelLevelTypes[HotelLevelTypes.FourStars] + ","
        );
    };

    const handleCheckedFiveStar = () => {
        setHotelLevelCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedFiveStar: !hotelLevelCheck.isCheckedFiveStar,
        }));
        handleChangeHotelLevelType(
            !hotelLevelCheck.isCheckedFiveStar,
            HotelLevelTypes[HotelLevelTypes.FiveStars] + ","
        );
    };

    function handleChangeHotelLevelType(isChange: boolean, enumType: string) {
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            hotelLevelType: isChange
                ? (prevData.hotelLevelType ?? "") + enumType
                : prevData.hotelLevelType?.replace(enumType, "") ?? "",
        }));
    }

    function handleCheckedFirstNight() {
        setSpecialRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedFirstNight: !specialRequestCheck.isCheckedFirstNight,
        }));
        handleChangeSpecialRequestType(
            !specialRequestCheck.isCheckedFirstNight,
            SpecialRequestStayTypes[SpecialRequestStayTypes.FirstNight] + ","
        );
    }

    function handleCheckedSecondNight() {
        setSpecialRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedSecondNight: !specialRequestCheck.isCheckedSecondNight,
        }));
        handleChangeSpecialRequestType(
            !specialRequestCheck.isCheckedSecondNight,
            SpecialRequestStayTypes[SpecialRequestStayTypes.SecondNight] + ","
        );
    }

    function handleCheckedThirdNight() {
        setSpecialRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedThirdNight: !specialRequestCheck.isCheckedThirdNight,
        }));
        handleChangeSpecialRequestType(
            !specialRequestCheck.isCheckedThirdNight,
            SpecialRequestStayTypes[SpecialRequestStayTypes.ThirdNight] + ","
        );
    }

    function handleCheckedFourthNight() {
        setSpecialRequestCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedFourthNight: !specialRequestCheck.isCheckedFourthNight,
        }));
        handleChangeSpecialRequestType(
            !specialRequestCheck.isCheckedFourthNight,
            SpecialRequestStayTypes[SpecialRequestStayTypes.FourthNight] + ","
        );
    }

    function handleChangeSpecialRequestType(isChange: boolean, enumType: string) {
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            specialRequestStayType: isChange
                ? (prevData.specialRequestStayType ?? "") + enumType
                : prevData.specialRequestStayType?.replace(enumType, "") ?? "",
        }));
    }

    function handleCheckedDrinkOne() {
        setAdditionDrinkCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedDrinkOne: !additionDrinkCheck.isCheckedDrinkOne,
        }));
        handleChangeAdditionDrinksType(
            !additionDrinkCheck.isCheckedDrinkOne,
            AdditionDrinksTypes[AdditionDrinksTypes.DrinksOne] + ","
        );
    }

    function handleCheckedDrinkTwo() {
        setAdditionDrinkCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedDrinkTwo: !additionDrinkCheck.isCheckedDrinkTwo,
        }));
        handleChangeAdditionDrinksType(
            !additionDrinkCheck.isCheckedDrinkTwo,
            AdditionDrinksTypes[AdditionDrinksTypes.DrinksTwo] + ","
        );
    }

    function handleCheckedDrinkThree() {
        setAdditionDrinkCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedDrinkThree: !additionDrinkCheck.isCheckedDrinkThree,
        }));
        handleChangeAdditionDrinksType(
            !additionDrinkCheck.isCheckedDrinkThree,
            AdditionDrinksTypes[AdditionDrinksTypes.DrinksThree] + ","
        );
    }

    function handleCheckedDrinkFour() {
        setAdditionDrinkCheck((prevChecked) => ({
            ...prevChecked,
            isCheckedDrinkFour: !additionDrinkCheck.isCheckedDrinkFour,
        }));
        handleChangeAdditionDrinksType(
            !additionDrinkCheck.isCheckedDrinkFour,
            AdditionDrinksTypes[AdditionDrinksTypes.DrinksFour] + ","
        );
    }

    function handleChangeAdditionDrinksType(isChange: boolean, enumType: string) {
        setCreateGroupOrderRequest((prevData) => ({
            ...prevData,
            additionDrinksType: isChange
                ? (prevData.additionDrinksType ?? "") + enumType
                : prevData.additionDrinksType?.replace(enumType, "") ?? "",
        }));
    }

    const submitOnClick = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        popupService.showLoading();
        if (
            !createGroupOrderRequest.alternativeHolidayDateOne ||
            !createGroupOrderRequest.alternativeHolidayDateTwo ||
            createGroupOrderRequest.alternativeHolidayDateThree === ""
        ) {
            popupService.showError(t("error.InvalidDate"));
            return;
        }
        try {
            const request: CreateGroupOrderRequest = {
                groupName: createGroupOrderRequest.groupName,
                mobile: createGroupOrderRequest.mobile,
                email: createGroupOrderRequest.email,
                alternativeHolidayDateOne: createGroupOrderRequest.alternativeHolidayDateOne,
                alternativeHolidayDateTwo: createGroupOrderRequest.alternativeHolidayDateTwo,
                alternativeHolidayDateThree: createGroupOrderRequest.alternativeHolidayDateThree,
                alternativeHolidayDateComments: createGroupOrderRequest.alternativeHolidayDateComments,
                budgetPerEmployee: createGroupOrderRequest.budgetPerEmployee,
                budgetForCouple: createGroupOrderRequest.budgetForCouple,
                familyBudget: createGroupOrderRequest.familyBudget,
                budgetComments: createGroupOrderRequest.budgetComments,
                desiredRegionOneId: createGroupOrderRequest.desiredRegionOneId,
                desiredRegionTwoId: createGroupOrderRequest.desiredRegionTwoId,
                desiredRegionThreeId: createGroupOrderRequest.desiredRegionThreeId,
                needBus: createGroupOrderRequest.needBus,
                needGuide: createGroupOrderRequest.needGuide,
                visitors: createGroupOrderRequest.visitors,
                wantIncorporateLectureRecognition: createGroupOrderRequest.wantIncorporateLectureRecognition,
                incorporateLectureRecognitionBudget: createGroupOrderRequest.incorporateLectureRecognitionBudget,
                incorporateLectureRecognitionComments: createGroupOrderRequest.incorporateLectureRecognitionComments,
                mealType: createGroupOrderRequest.mealType,
                mealComments: createGroupOrderRequest.mealComments,
                additionCoffeeCake: createGroupOrderRequest.additionCoffeeCake,
                additionCoffeeCakeComments: createGroupOrderRequest.additionCoffeeCakeComments,
                additionDrinksComments: createGroupOrderRequest.additionDrinksComments,
                additionDrinksOnEvent: createGroupOrderRequest.additionDrinksOnEvent,
                additionDrinksType: createGroupOrderRequest.additionDrinksType,
                artistPerformanceComments: createGroupOrderRequest.artistPerformanceComments,
                artistPerformanceType: createGroupOrderRequest.artistPerformanceType,
                eveningArtistBudget: createGroupOrderRequest.eveningArtistBudget,
                generalBudget: createGroupOrderRequest.generalBudget,
                hotelLevelType: createGroupOrderRequest.hotelLevelType,
                interestedArtist: createGroupOrderRequest.interestedArtist,
                interestedTrip: createGroupOrderRequest.interestedTrip,
                interestedTripBudget: createGroupOrderRequest.interestedTripBudget,
                interestedTripComments: createGroupOrderRequest.interestedTripComments,
                messageTypes: createGroupOrderRequest.messageTypes,
                numberRoomsDesired: createGroupOrderRequest.numberRoomsDesired,
                otherEventsNeeded: createGroupOrderRequest.otherEventsNeeded,
                otherEventsNeededComments: createGroupOrderRequest.otherEventsNeededComments,
                purposeOfVacation: createGroupOrderRequest.purposeOfVacation,
                specialRequestStayType: createGroupOrderRequest.specialRequestStayType,
                stayingRequestComments: createGroupOrderRequest.stayingRequestComments,
                stayingRequestType: createGroupOrderRequest.stayingRequestType,
            };
            await api.createGroupOrderForm(request);
            await popupService.showSuccess(t("forms.CreateGroupOrder.AddedMsg"));
            navigate("/forms");
        } catch (err) {
            popupService.showApiError(err);
            return;
        }
    };

    useEffect(() => {
        let ignore = false;
        if (!ignore) {
            getCreateGroupOrderInitData();
        }
        return () => {
            ignore = true;
        };
    }, []);

    return (
        <div className="create-group-order-container">
            <div className="create-group-order-header">
                {t("forms.CreateGroupOrder.Header")} (Organisa name/{formatDate(currentDate.toDateString())})
            </div>
            <form onSubmit={submitOnClick}>
                <div className="create-group-order-content">
                    <div className="create-group-order-content-up">
                        <BaseButton onClick={() => navigate("/forms")} type="button" className="basic-button">
                            <img className="back-to-list-arrow" src={ArrowElement} alt="ArrowElement" />
                            <div>{t("forms.BackToFormsBtn")}</div>
                        </BaseButton>
                    </div>
                    <div className="create-group-order-content-middle">
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                            <div>
                                <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                    {t("forms.CreateGroupOrder.Message")}
                                </div>
                                <div className="create-group-order-data-message">
                                    <RadioGroup defaultValue={FormMessageTypes.MessageOne}>
                                        <FormControlLabel
                                            value={FormMessageTypes.MessageOne}
                                            control={
                                                <Radio
                                                    size="small"
                                                    sx={{
                                                        "&, &.Mui-checked": {
                                                            color: "#405289",
                                                        },
                                                    }}
                                                />
                                            }
                                            onChange={(event: any) =>
                                                setCreateGroupOrderRequest((prevData) => ({
                                                    ...prevData,
                                                    messageTypes: event.target.value,
                                                }))
                                            }
                                            label={t("forms.CreateGroupOrder.MessageTextFirst")}
                                            sx={{ height: "28.5px", marginRight: "-11px" }}
                                            className="forms-radio-btn-text"
                                        />
                                        <FormControlLabel
                                            value={FormMessageTypes.MessageTwo}
                                            control={
                                                <Radio
                                                    size="small"
                                                    sx={{
                                                        "&, &.Mui-checked": {
                                                            color: "#405289",
                                                        },
                                                    }}
                                                />
                                            }
                                            onChange={(event: any) =>
                                                setCreateGroupOrderRequest((prevData) => ({
                                                    ...prevData,
                                                    messageTypes: event.target.value,
                                                }))
                                            }
                                            label={t("forms.CreateGroupOrder.MessageTextSecond")}
                                            sx={{ height: "28.5px", marginRight: "-11px" }}
                                            className="forms-radio-btn-text"
                                        />
                                        <FormControlLabel
                                            value={FormMessageTypes.MessageThree}
                                            control={
                                                <Radio
                                                    size="small"
                                                    color="default"
                                                    sx={{
                                                        "&, &.Mui-checked": {
                                                            color: "#405289",
                                                        },
                                                    }}
                                                />
                                            }
                                            onChange={(event: any) =>
                                                setCreateGroupOrderRequest((prevData) => ({
                                                    ...prevData,
                                                    messageTypes: event.target.value,
                                                }))
                                            }
                                            label={t("forms.CreateGroupOrder.MessageTextThird")}
                                            sx={{ height: "28.5px", marginRight: "-11px" }}
                                            className="forms-radio-btn-text"
                                        />
                                    </RadioGroup>
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                            <div>
                                <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                    {t("forms.CreateGroupOrder.PersonalInfo")}
                                </div>
                                <div className="create-group-order-data-personal-info">
                                    <div>
                                        <BaseInput
                                            required
                                            label={t("forms.CreateGroupOrder.GroupName")}
                                            type="search"
                                            size="small"
                                            value={createGroupOrderRequest.groupName}
                                            onChange={(event) =>
                                                setCreateGroupOrderRequest((prevData) => ({
                                                    ...prevData,
                                                    groupName: event.target.value,
                                                }))
                                            }
                                            fullWidth
                                        />
                                    </div>
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
                                        <div>
                                            <BaseInput
                                                required
                                                label={t("forms.CreateGroupOrder.Mobile")}
                                                type="search"
                                                size="small"
                                                value={createGroupOrderRequest.mobile}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        mobile: event.target.value,
                                                    }))
                                                }
                                                fullWidth
                                            />
                                        </div>
                                        <div>
                                            <BaseInput
                                                required
                                                label={t("forms.CreateGroupOrder.EmailAddress")}
                                                type="search"
                                                size="small"
                                                value={createGroupOrderRequest.email}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        email: event.target.value,
                                                    }))
                                                }
                                                fullWidth
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                    {t("forms.CreateGroupOrder.OrderAim")}
                                </div>
                                <div className="create-group-order-data-order-aim">
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
                                        <div>
                                            <BaseInput
                                                required
                                                label={t("forms.CreateGroupOrder.PurposeVacation")}
                                                type="search"
                                                size="small"
                                                value={createGroupOrderRequest.purposeOfVacation}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        purposeOfVacation: event.target.value,
                                                    }))
                                                }
                                                fullWidth
                                            />
                                        </div>
                                        <div>
                                            <BaseInput
                                                required
                                                label={t("forms.CreateGroupOrder.NumberRoomsDesired")}
                                                type="number"
                                                size="small"
                                                value={createGroupOrderRequest.numberRoomsDesired}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        numberRoomsDesired: Number(event.target.value),
                                                    }))
                                                }
                                                fullWidth
                                            />
                                        </div>
                                    </div>
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "15px" }}>
                                        <div>
                                            <BaseInput
                                                required
                                                select
                                                label={t("forms.CreateGroupOrder.DesiredRegions")}
                                                type="search"
                                                size="small"
                                                value={createGroupOrderRequest.desiredRegionOneId}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        desiredRegionOneId: Number(event.target.value),
                                                    }))
                                                }
                                                fullWidth
                                            >
                                                {regions.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.text}
                                                    </MenuItem>
                                                ))}
                                            </BaseInput>
                                        </div>
                                        <div>
                                            <BaseInput
                                                required
                                                select
                                                label={t("forms.CreateGroupOrder.DesiredRegions")}
                                                type="search"
                                                size="small"
                                                value={createGroupOrderRequest.desiredRegionTwoId}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        desiredRegionTwoId: Number(event.target.value),
                                                    }))
                                                }
                                                fullWidth
                                            >
                                                {regions.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.text}
                                                    </MenuItem>
                                                ))}
                                            </BaseInput>
                                        </div>
                                        <div>
                                            <BaseInput
                                                required
                                                select
                                                label={t("forms.CreateGroupOrder.DesiredRegions")}
                                                type="search"
                                                size="small"
                                                value={createGroupOrderRequest.desiredRegionThreeId}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        desiredRegionThreeId: Number(event.target.value),
                                                    }))
                                                }
                                                fullWidth
                                            >
                                                {regions.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.text}
                                                    </MenuItem>
                                                ))}
                                            </BaseInput>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 0.452fr", gap: "20px" }}>
                            <div style={{ display: "grid", gridTemplateRows: "1fr 0.2fr", gap: "20px" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                                    <div>
                                        <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                            {t("forms.CreateGroupOrder.Budget")}
                                        </div>
                                        <div className="create-group-order-data-budget">
                                            <div>
                                                <BaseInput
                                                    required
                                                    label={t("forms.CreateGroupOrder.BudgetEmployee")}
                                                    type="search"
                                                    size="small"
                                                    fullWidth
                                                    value={createGroupOrderRequest.budgetPerEmployee}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            budgetPerEmployee: event.target.value,
                                                        }))
                                                    }
                                                    InputProps={{
                                                        inputComponent: NumericFormatCustom as any,
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <BaseInput
                                                    required
                                                    label={t("forms.CreateGroupOrder.FamilyBudget")}
                                                    type="search"
                                                    size="small"
                                                    fullWidth
                                                    value={createGroupOrderRequest.familyBudget}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            familyBudget: event.target.value,
                                                        }))
                                                    }
                                                    InputProps={{
                                                        inputComponent: NumericFormatCustom as any,
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <BaseInput
                                                    required
                                                    label={t("forms.CreateGroupOrder.BudgetCouple")}
                                                    type="search"
                                                    fullWidth
                                                    size="small"
                                                    value={createGroupOrderRequest.budgetForCouple}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            budgetForCouple: event.target.value,
                                                        }))
                                                    }
                                                    InputProps={{
                                                        inputComponent: NumericFormatCustom as any,
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <BaseInput
                                                    multiline
                                                    maxRows={6}
                                                    label={t("forms.CreateGroupOrder.Comments")}
                                                    type="text"
                                                    size="small"
                                                    value={createGroupOrderRequest.budgetComments}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            budgetComments: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    sx={{
                                                        height: 165,
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            height: "100%",
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                            {t("forms.CreateGroupOrder.StayingRequest")}
                                        </div>
                                        <div className="create-group-order-data-staying-request">
                                            <div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={stayingRequestCheck.isCheckedWeekendOne}
                                                        onChange={handleCheckedWeekendOne}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.WeekendOneNight")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={stayingRequestCheck.isCheckedWeekendTwo}
                                                        onChange={handleCheckedWeekendTwo}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.WeekendTwoNight")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={stayingRequestCheck.isCheckedMidweekOne}
                                                        onChange={handleCheckedMidweekOne}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.MidweekOneNight")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={stayingRequestCheck.isCheckedMidweekTwo}
                                                        onChange={handleCheckedMidweekTwo}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.MidweekTwoNights")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={stayingRequestCheck.isCheckedMidweekThree}
                                                        onChange={handleCheckedMidweekThree}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.MidweekThreeNights")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={stayingRequestCheck.isCheckedMidweekFour}
                                                        onChange={handleCheckedMidweekFour}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.MidweekFourNights")}
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ padding: "0px 12px" }}>
                                                <BaseInput
                                                    multiline
                                                    maxRows={7}
                                                    label={t("forms.CreateGroupOrder.Comments")}
                                                    type="text"
                                                    size="small"
                                                    value={createGroupOrderRequest.stayingRequestComments}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            stayingRequestComments: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    sx={{
                                                        height: 177,
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            height: "100%",
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.CreateGroupOrder.Boardbase")}
                                    </div>
                                    <div className="create-group-order-data-boardbase">
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                                            <div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={mealTypeCheck.isCheckedRefreshmentsArrival}
                                                        onChange={handleCheckedRefreshmentsOnArrival}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.RefreshmentsOnArrival")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={mealTypeCheck.isCheckedFullBreakfast}
                                                        onChange={handleCheckedFullBreakfast}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.FullBreakfast")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={mealTypeCheck.isCheckedRefreshmentsWay}
                                                        onChange={handleCheckedRefreshmentsWay}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.RefreshmentsOnTheWay")}
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={mealTypeCheck.isCheckedLunch}
                                                        onChange={handleCheckedLunch}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.Lunch")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={mealTypeCheck.isCheckedDinner}
                                                        onChange={handleCheckedDinner}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.Dinner")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ paddingInlineEnd: "12px" }}>
                                                <BaseInput
                                                    multiline
                                                    maxRows={3}
                                                    label={t("forms.CreateGroupOrder.Comments")}
                                                    type="text"
                                                    size="small"
                                                    value={createGroupOrderRequest.mealComments}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            mealComments: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    sx={{
                                                        height: 89,
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            height: "100%",
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "grid", gap: "20px" }}>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.CreateGroupOrder.HotelLevel")}
                                    </div>
                                    <div className="create-group-order-data-hotel-level">
                                        <div style={{ display: "flex", alignItems: "center", height: "29.5px" }}>
                                            <Checkbox
                                                sx={{
                                                    "&.Mui-checked": {
                                                        color: "#2EA984",
                                                    },
                                                }}
                                                checked={hotelLevelCheck.isCheckedThreeStar}
                                                onChange={handleCheckedThreeStar}
                                            />
                                            <div style={{ opacity: "0.7" }} className="font-style">
                                                {t("forms.CreateGroupOrder.ThreeStars")}
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", height: "29.5px" }}>
                                            <Checkbox
                                                sx={{
                                                    "&.Mui-checked": {
                                                        color: "#2EA984",
                                                    },
                                                }}
                                                checked={hotelLevelCheck.isCheckedFourStar}
                                                onChange={handleCheckedFourStar}
                                            />
                                            <div style={{ opacity: "0.7" }} className="font-style">
                                                {t("forms.CreateGroupOrder.FourStars")}
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", height: "29.5px" }}>
                                            <Checkbox
                                                sx={{
                                                    "&.Mui-checked": {
                                                        color: "#2EA984",
                                                    },
                                                }}
                                                checked={hotelLevelCheck.isCheckedFiveStar}
                                                onChange={handleCheckedFiveStar}
                                            />
                                            <div style={{ opacity: "0.7" }} className="font-style">
                                                {t("forms.CreateGroupOrder.FiveStars")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.CreateGroupOrder.Visitors")}
                                    </div>
                                    <div className="fun-day-data-radio-btn">
                                        <RadioGroup defaultValue={VisitorsTypes.EmployeesOnly}>
                                            <FormControlLabel
                                                value={VisitorsTypes.EmployeesOnly}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        sx={{
                                                            "&, &.Mui-checked": {
                                                                color: "#405289",
                                                            },
                                                        }}
                                                    />
                                                }
                                                onChange={(event: any) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        visitors: event.target.value,
                                                    }))
                                                }
                                                label={t("forms.CreateGroupOrder.EmployeesOnly")}
                                                sx={{ height: "28.5px", marginRight: "-11px" }}
                                                className="forms-radio-btn-text"
                                            />
                                            <FormControlLabel
                                                value={VisitorsTypes.IncludingCouples}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        sx={{
                                                            "&, &.Mui-checked": {
                                                                color: "#405289",
                                                            },
                                                        }}
                                                    />
                                                }
                                                onChange={(event: any) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        visitors: event.target.value,
                                                    }))
                                                }
                                                label={t("forms.CreateGroupOrder.IncludingCouples")}
                                                sx={{ height: "28.5px", marginRight: "-11px" }}
                                                className="forms-radio-btn-text"
                                            />
                                            <FormControlLabel
                                                value={VisitorsTypes.Families}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        color="default"
                                                        sx={{
                                                            "&, &.Mui-checked": {
                                                                color: "#405289",
                                                            },
                                                        }}
                                                    />
                                                }
                                                onChange={(event: any) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        visitors: event.target.value,
                                                    }))
                                                }
                                                label={t("forms.CreateGroupOrder.Families")}
                                                sx={{ height: "28.5px", marginRight: "-11px" }}
                                                className="forms-radio-btn-text"
                                            />
                                        </RadioGroup>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.CreateGroupOrder.NeedBus")}
                                    </div>
                                    <div className="fun-day-data-radio-btn">
                                        <RadioGroup defaultValue={true}>
                                            <FormControlLabel
                                                value={true}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        sx={{
                                                            "&, &.Mui-checked": {
                                                                color: "#405289",
                                                            },
                                                        }}
                                                    />
                                                }
                                                onChange={() =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        needBus: true,
                                                    }))
                                                }
                                                label={t("forms.Yes")}
                                                sx={{ height: "28.5px", marginRight: "-11px" }}
                                                className="forms-radio-btn-text"
                                            />
                                            <FormControlLabel
                                                value={false}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        sx={{
                                                            "&, &.Mui-checked": {
                                                                color: "#405289",
                                                            },
                                                        }}
                                                    />
                                                }
                                                onChange={() =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        needBus: false,
                                                    }))
                                                }
                                                label={t("forms.No")}
                                                sx={{ height: "28.5px", marginRight: "-11px" }}
                                                className="forms-radio-btn-text"
                                            />
                                        </RadioGroup>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.CreateGroupOrder.NeedGuide")}
                                    </div>
                                    <div className="fun-day-data-radio-btn">
                                        <RadioGroup defaultValue={true}>
                                            <FormControlLabel
                                                value={true}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        sx={{
                                                            "&, &.Mui-checked": {
                                                                color: "#405289",
                                                            },
                                                        }}
                                                    />
                                                }
                                                onChange={() =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        needGuide: true,
                                                    }))
                                                }
                                                label={t("forms.Yes")}
                                                sx={{ height: "28.5px", marginRight: "-11px" }}
                                                className="forms-radio-btn-text"
                                            />
                                            <FormControlLabel
                                                value={false}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        sx={{
                                                            "&, &.Mui-checked": {
                                                                color: "#405289",
                                                            },
                                                        }}
                                                    />
                                                }
                                                onChange={() =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        needGuide: false,
                                                    }))
                                                }
                                                label={t("forms.No")}
                                                sx={{ height: "28.5px", marginRight: "-11px" }}
                                                className="forms-radio-btn-text"
                                            />
                                        </RadioGroup>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px" }}>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.GroupOrder.InterestedInTrip")}
                                    </div>
                                    <div className="create-group-order-data-interested-trip">
                                        <div style={{ display: "grid", gap: "15px" }}>
                                            <div>
                                                <RadioGroup defaultValue={true}>
                                                    <FormControlLabel
                                                        value={true}
                                                        control={
                                                            <Radio
                                                                size="small"
                                                                sx={{
                                                                    "&, &.Mui-checked": {
                                                                        color: "#405289",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        onChange={() =>
                                                            setCreateGroupOrderRequest((prevData) => ({
                                                                ...prevData,
                                                                interestedTrip: true,
                                                            }))
                                                        }
                                                        label={t("forms.Yes")}
                                                        sx={{ height: "28.5px", marginRight: "-11px" }}
                                                        className="forms-radio-btn-text"
                                                    />
                                                    <FormControlLabel
                                                        value={false}
                                                        control={
                                                            <Radio
                                                                size="small"
                                                                sx={{
                                                                    "&, &.Mui-checked": {
                                                                        color: "#405289",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        onChange={() =>
                                                            setCreateGroupOrderRequest((prevData) => ({
                                                                ...prevData,
                                                                interestedTrip: false,
                                                            }))
                                                        }
                                                        label={t("forms.No")}
                                                        sx={{ height: "28.5px", marginRight: "-11px" }}
                                                        className="forms-radio-btn-text"
                                                    />
                                                </RadioGroup>
                                            </div>
                                            <div>
                                                <BaseInput
                                                    label={t("forms.CreateGroupOrder.Budget")}
                                                    type="search"
                                                    size="small"
                                                    value={createGroupOrderRequest.interestedTripBudget}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            interestedTripBudget: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    InputProps={{
                                                        inputComponent: NumericFormatCustom as any,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <BaseInput
                                                multiline
                                                maxRows={5}
                                                label={t("forms.CreateGroupOrder.Comments")}
                                                type="text"
                                                size="small"
                                                value={createGroupOrderRequest.interestedTripComments}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        interestedTripComments: event.target.value,
                                                    }))
                                                }
                                                fullWidth
                                                sx={{
                                                    height: 127,
                                                }}
                                                inputProps={{
                                                    style: {
                                                        height: "100%",
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.GroupOrder.IncorporateLecture")}
                                    </div>
                                    <div className="create-group-order-data-incorporate">
                                        <div style={{ display: "grid", gap: "15px" }}>
                                            <div>
                                                <RadioGroup defaultValue={true}>
                                                    <FormControlLabel
                                                        value={true}
                                                        control={
                                                            <Radio
                                                                size="small"
                                                                sx={{
                                                                    "&, &.Mui-checked": {
                                                                        color: "#405289",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        onChange={() =>
                                                            setCreateGroupOrderRequest((prevData) => ({
                                                                ...prevData,
                                                                wantIncorporateLectureRecognition: true,
                                                            }))
                                                        }
                                                        label={t("forms.Yes")}
                                                        sx={{ height: "28.5px", marginRight: "-11px" }}
                                                        className="forms-radio-btn-text"
                                                    />
                                                    <FormControlLabel
                                                        value={false}
                                                        control={
                                                            <Radio
                                                                size="small"
                                                                sx={{
                                                                    "&, &.Mui-checked": {
                                                                        color: "#405289",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        onChange={() =>
                                                            setCreateGroupOrderRequest((prevData) => ({
                                                                ...prevData,
                                                                wantIncorporateLectureRecognition: false,
                                                            }))
                                                        }
                                                        label={t("forms.No")}
                                                        sx={{ height: "28.5px", marginRight: "-11px" }}
                                                        className="forms-radio-btn-text"
                                                    />
                                                </RadioGroup>
                                            </div>
                                            <div>
                                                <BaseInput
                                                    label={t("forms.CreateGroupOrder.Budget")}
                                                    type="search"
                                                    size="small"
                                                    value={createGroupOrderRequest.incorporateLectureRecognitionBudget}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            incorporateLectureRecognitionBudget: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    InputProps={{
                                                        inputComponent: NumericFormatCustom as any,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <BaseInput
                                                multiline
                                                maxRows={5}
                                                label={t("forms.CreateGroupOrder.Comments")}
                                                type="text"
                                                size="small"
                                                fullWidth
                                                value={createGroupOrderRequest.incorporateLectureRecognitionComments}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        incorporateLectureRecognitionComments: event.target.value,
                                                    }))
                                                }
                                                sx={{
                                                    height: 127,
                                                }}
                                                inputProps={{
                                                    style: {
                                                        height: "100%",
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                        {t("forms.CreateGroupOrder.AlternativeHolidayDates")}
                                    </div>
                                    <div className="create-group-order-data-alternative-holiday">
                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className="date-picker-input"
                                                    renderInput={(params) => <BaseDateInput required {...params} />}
                                                    value={createGroupOrderRequest.alternativeHolidayDateOne}
                                                    onChange={(event) => handleOnChangeDateOne(event)}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className="date-picker-input"
                                                    renderInput={(params) => <BaseDateInput required {...params} />}
                                                    value={createGroupOrderRequest.alternativeHolidayDateTwo}
                                                    onChange={(event) => handleOnChangeDateTwo(event)}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className="date-picker-input"
                                                    renderInput={(params) => <BaseDateInput {...params} />}
                                                    value={createGroupOrderRequest.alternativeHolidayDateThree}
                                                    onChange={(event) => handleOnChangeDateThree(event)}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        <div>
                                            <BaseInput
                                                multiline
                                                maxRows={3}
                                                label={t("forms.CreateGroupOrder.Comments")}
                                                type="text"
                                                size="small"
                                                fullWidth
                                                value={createGroupOrderRequest.alternativeHolidayDateComments}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        alternativeHolidayDateComments: event.target.value,
                                                    }))
                                                }
                                                sx={{
                                                    height: 74,
                                                }}
                                                inputProps={{
                                                    style: {
                                                        height: "100%",
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "grid", gridTemplateRows: "397px 242px", gap: "20px" }}>
                            <div>
                                <div style={{ paddingBottom: "20px" }} className="font-style-18">
                                    {t("forms.CreateGroupOrder.SpecialRequest")}
                                </div>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                                    <div
                                        style={{ display: "grid", gridTemplateColumns: "0.7fr 1fr" }}
                                        className="create-group-order-data-special-request-first"
                                    >
                                        <div>
                                            <div style={{ paddingInlineStart: "12px", paddingBottom: "12px" }}>
                                                <div style={{ paddingBottom: "12px" }} className="font-style">
                                                    {t("forms.CreateGroupOrder.InterestedInArtist")}
                                                </div>
                                                <div>
                                                    <RadioGroup defaultValue={true}>
                                                        <FormControlLabel
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    sx={{
                                                                        "&, &.Mui-checked": {
                                                                            color: "#405289",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            value={true}
                                                            onChange={() =>
                                                                setCreateGroupOrderRequest((prevData) => ({
                                                                    ...prevData,
                                                                    interestedArtist: true,
                                                                }))
                                                            }
                                                            label={t("forms.Yes")}
                                                            sx={{ height: "28.5px", marginRight: "-11px" }}
                                                            className="forms-radio-btn-text"
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    sx={{
                                                                        "&, &.Mui-checked": {
                                                                            color: "#405289",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            value={false}
                                                            onChange={() =>
                                                                setCreateGroupOrderRequest((prevData) => ({
                                                                    ...prevData,
                                                                    interestedArtist: false,
                                                                }))
                                                            }
                                                            label={t("forms.No")}
                                                            sx={{ height: "28.5px", marginRight: "-11px" }}
                                                            className="forms-radio-btn-text"
                                                        />
                                                    </RadioGroup>
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={specialRequestCheck.isCheckedFirstNight}
                                                        onChange={handleCheckedFirstNight}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.FirstNight")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={specialRequestCheck.isCheckedSecondNight}
                                                        onChange={handleCheckedSecondNight}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.SecondNight")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={specialRequestCheck.isCheckedThirdNight}
                                                        onChange={handleCheckedThirdNight}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.ThirdNight")}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ display: "flex", alignItems: "center", height: "29.5px" }}
                                                >
                                                    <Checkbox
                                                        sx={{
                                                            "&.Mui-checked": {
                                                                color: "#2EA984",
                                                            },
                                                        }}
                                                        checked={specialRequestCheck.isCheckedFourthNight}
                                                        onChange={handleCheckedFourthNight}
                                                    />
                                                    <div style={{ opacity: "0.7" }} className="font-style">
                                                        {t("forms.CreateGroupOrder.FourthNight")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "grid",
                                                gap: "20px",
                                                paddingInlineEnd: "12px",
                                                gridTemplateRows: "40px 40px 1fr",
                                            }}
                                        >
                                            <div>
                                                <BaseInput
                                                    label={t("forms.CreateGroupOrder.BudgetForEveningArtist")}
                                                    type="search"
                                                    size="small"
                                                    value={createGroupOrderRequest.eveningArtistBudget}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            eveningArtistBudget: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    InputProps={{
                                                        inputComponent: NumericFormatCustom as any,
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <BaseInput
                                                    label={t("forms.CreateGroupOrder.GeneralBudget")}
                                                    type="search"
                                                    size="small"
                                                    value={createGroupOrderRequest.generalBudget}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            generalBudget: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    InputProps={{
                                                        inputComponent: NumericFormatCustom as any,
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <div style={{ paddingBottom: "15px" }} className="font-style">
                                                    {t("forms.CreateGroupOrder.Description")}
                                                </div>
                                                <div className="font-style">
                                                    {t("forms.CreateGroupOrder.DescriptionText")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="create-group-order-data-special-request-first">
                                        <div style={{ paddingInlineStart: "12px", paddingBottom: "12px" }}>
                                            <div style={{ paddingBottom: "12px" }} className="font-style">
                                                {t("forms.CreateGroupOrder.AdditionDrinksEvent")}
                                            </div>
                                            <div>
                                                <RadioGroup defaultValue={true}>
                                                    <FormControlLabel
                                                        value={true}
                                                        onChange={() =>
                                                            setCreateGroupOrderRequest((prevData) => ({
                                                                ...prevData,
                                                                additionDrinksOnEvent: true,
                                                            }))
                                                        }
                                                        control={
                                                            <Radio
                                                                size="small"
                                                                sx={{
                                                                    "&, &.Mui-checked": {
                                                                        color: "#405289",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label={t("forms.Yes")}
                                                        sx={{ height: "28.5px", marginRight: "-11px" }}
                                                        className="forms-radio-btn-text"
                                                    />
                                                    <FormControlLabel
                                                        value={false}
                                                        onChange={() =>
                                                            setCreateGroupOrderRequest((prevData) => ({
                                                                ...prevData,
                                                                additionDrinksOnEvent: false,
                                                            }))
                                                        }
                                                        control={
                                                            <Radio
                                                                size="small"
                                                                sx={{
                                                                    "&, &.Mui-checked": {
                                                                        color: "#405289",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label={t("forms.No")}
                                                        sx={{ height: "28.5px", marginRight: "-11px" }}
                                                        className="forms-radio-btn-text"
                                                    />
                                                </RadioGroup>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ display: "flex", alignItems: "center", height: "29.5px" }}>
                                                <Checkbox
                                                    sx={{
                                                        "&.Mui-checked": {
                                                            color: "#2EA984",
                                                        },
                                                    }}
                                                    checked={additionDrinkCheck.isCheckedDrinkOne}
                                                    onChange={handleCheckedDrinkOne}
                                                />
                                                <div style={{ opacity: "0.7" }} className="font-style">
                                                    {t("forms.CreateGroupOrder.DrinksOne")}
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", height: "29.5px" }}>
                                                <Checkbox
                                                    sx={{
                                                        "&.Mui-checked": {
                                                            color: "#2EA984",
                                                        },
                                                    }}
                                                    checked={additionDrinkCheck.isCheckedDrinkTwo}
                                                    onChange={handleCheckedDrinkTwo}
                                                />
                                                <div style={{ opacity: "0.7" }} className="font-style">
                                                    {t("forms.CreateGroupOrder.DrinksTwo")}
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", height: "29.5px" }}>
                                                <Checkbox
                                                    sx={{
                                                        "&.Mui-checked": {
                                                            color: "#2EA984",
                                                        },
                                                    }}
                                                    checked={additionDrinkCheck.isCheckedDrinkThree}
                                                    onChange={handleCheckedDrinkThree}
                                                />
                                                <div style={{ opacity: "0.7" }} className="font-style">
                                                    {t("forms.CreateGroupOrder.DrinksThree")}
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", height: "29.5px" }}>
                                                <Checkbox
                                                    sx={{
                                                        "&.Mui-checked": {
                                                            color: "#2EA984",
                                                        },
                                                    }}
                                                    checked={additionDrinkCheck.isCheckedDrinkFour}
                                                    onChange={handleCheckedDrinkFour}
                                                />
                                                <div style={{ opacity: "0.7" }} className="font-style">
                                                    {t("forms.CreateGroupOrder.DrinksFour")}
                                                </div>
                                            </div>
                                            <div style={{ padding: "0px 12px", paddingTop: "14px" }}>
                                                <BaseInput
                                                    multiline
                                                    maxRows={3}
                                                    label={t("forms.CreateGroupOrder.Comments")}
                                                    type="text"
                                                    size="small"
                                                    value={createGroupOrderRequest.additionDrinksComments}
                                                    onChange={(event) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            additionDrinksComments: event.target.value,
                                                        }))
                                                    }
                                                    fullWidth
                                                    sx={{
                                                        height: 85,
                                                    }}
                                                    inputProps={{
                                                        style: {
                                                            height: "100%",
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px" }}>
                                <div className="create-group-order-data-special-artist-performance">
                                    <div style={{ padding: "0px 12px" }}>
                                        <div style={{ paddingBottom: "12px" }} className="font-style">
                                            {t("forms.ArtistPerformance")}
                                        </div>
                                        <div style={{ paddingBottom: "15px" }}>
                                            <RadioGroup defaultValue={ArtistPerformanceTypes.InsideHotel}>
                                                <FormControlLabel
                                                    value={ArtistPerformanceTypes.InsideHotel}
                                                    onChange={(event: any) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            artistPerformanceType: event.target.value,
                                                        }))
                                                    }
                                                    control={
                                                        <Radio
                                                            size="small"
                                                            sx={{
                                                                "&, &.Mui-checked": {
                                                                    color: "#405289",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Inside the hotel"
                                                    sx={{ height: "28.5px", marginRight: "-11px" }}
                                                    className="forms-radio-btn-text"
                                                />
                                                <FormControlLabel
                                                    value={ArtistPerformanceTypes.OutsideHotel}
                                                    onChange={(event: any) =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            artistPerformanceType: event.target.value,
                                                        }))
                                                    }
                                                    control={
                                                        <Radio
                                                            size="small"
                                                            sx={{
                                                                "&, &.Mui-checked": {
                                                                    color: "#405289",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Outside the hotel"
                                                    sx={{ height: "28.5px", marginRight: "-11px" }}
                                                    className="forms-radio-btn-text"
                                                />
                                            </RadioGroup>
                                        </div>
                                        <div>
                                            <BaseInput
                                                multiline
                                                maxRows={3}
                                                label={t("forms.CreateGroupOrder.Comments")}
                                                type="text"
                                                size="small"
                                                value={createGroupOrderRequest.artistPerformanceComments}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        artistPerformanceComments: event.target.value,
                                                    }))
                                                }
                                                fullWidth
                                                sx={{
                                                    height: 100,
                                                }}
                                                inputProps={{
                                                    style: {
                                                        height: "100%",
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="create-group-order-data-special-artist-performance">
                                    <div style={{ padding: "0px 12px" }}>
                                        <div style={{ paddingBottom: "12px" }} className="font-style">
                                            {t("forms.CreateGroupOrder.AdditionCoffeeCake")}
                                        </div>
                                        <div style={{ paddingBottom: "15px" }}>
                                            <RadioGroup defaultValue={true}>
                                                <FormControlLabel
                                                    value={true}
                                                    onChange={() =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            additionCoffeeCake: true,
                                                        }))
                                                    }
                                                    control={
                                                        <Radio
                                                            size="small"
                                                            sx={{
                                                                "&, &.Mui-checked": {
                                                                    color: "#405289",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={t("forms.Yes")}
                                                    sx={{ height: "28.5px", marginRight: "-11px" }}
                                                    className="forms-radio-btn-text"
                                                />
                                                <FormControlLabel
                                                    value={false}
                                                    onChange={() =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            additionCoffeeCake: false,
                                                        }))
                                                    }
                                                    control={
                                                        <Radio
                                                            size="small"
                                                            sx={{
                                                                "&, &.Mui-checked": {
                                                                    color: "#405289",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={t("forms.No")}
                                                    sx={{ height: "28.5px", marginRight: "-11px" }}
                                                    className="forms-radio-btn-text"
                                                />
                                            </RadioGroup>
                                        </div>
                                        <div>
                                            <BaseInput
                                                multiline
                                                maxRows={3}
                                                label={t("forms.CreateGroupOrder.Comments")}
                                                type="text"
                                                size="small"
                                                value={createGroupOrderRequest.additionCoffeeCakeComments}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        additionCoffeeCakeComments: event.target.value,
                                                    }))
                                                }
                                                fullWidth
                                                sx={{
                                                    height: 100,
                                                }}
                                                inputProps={{
                                                    style: {
                                                        height: "100%",
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="create-group-order-data-special-artist-performance">
                                    <div style={{ padding: "0px 12px" }}>
                                        <div style={{ paddingBottom: "12px" }} className="font-style">
                                            {t("forms.CreateGroupOrder.AnyOtherEvents")}
                                        </div>
                                        <div style={{ paddingBottom: "15px" }}>
                                            <RadioGroup defaultValue={true}>
                                                <FormControlLabel
                                                    value={true}
                                                    onChange={() =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            otherEventsNeeded: true,
                                                        }))
                                                    }
                                                    control={
                                                        <Radio
                                                            size="small"
                                                            sx={{
                                                                "&, &.Mui-checked": {
                                                                    color: "#405289",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={t("forms.Yes")}
                                                    sx={{ height: "28.5px", marginRight: "-11px" }}
                                                    className="forms-radio-btn-text"
                                                />
                                                <FormControlLabel
                                                    value={false}
                                                    onChange={() =>
                                                        setCreateGroupOrderRequest((prevData) => ({
                                                            ...prevData,
                                                            otherEventsNeeded: false,
                                                        }))
                                                    }
                                                    control={
                                                        <Radio
                                                            size="small"
                                                            sx={{
                                                                "&, &.Mui-checked": {
                                                                    color: "#405289",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={t("forms.No")}
                                                    sx={{ height: "28.5px", marginRight: "-11px" }}
                                                    className="forms-radio-btn-text"
                                                />
                                            </RadioGroup>
                                        </div>
                                        <div>
                                            <BaseInput
                                                multiline
                                                maxRows={3}
                                                label={t("forms.CreateGroupOrder.Comments")}
                                                type="text"
                                                size="small"
                                                value={createGroupOrderRequest.otherEventsNeededComments}
                                                onChange={(event) =>
                                                    setCreateGroupOrderRequest((prevData) => ({
                                                        ...prevData,
                                                        otherEventsNeededComments: event.target.value,
                                                    }))
                                                }
                                                fullWidth
                                                sx={{
                                                    height: 100,
                                                }}
                                                inputProps={{
                                                    style: {
                                                        height: "100%",
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="create-group-order-content-down">
                        <BaseButton
                            style={{ padding: "0px 63px" }}
                            type="button"
                            onClick={() => navigate("/forms")}
                            className="cancel-button"
                        >
                            {t("button.cancel")}
                        </BaseButton>
                        <BaseButton style={{ padding: "0px 63px" }} type="submit" className="edit-save-button">
                            {t("forms.SubmitBtn")}
                        </BaseButton>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default FormsCreateGroupOrder;
